/**
 * @flow
 * @relayHash 372a6d6f04a067da45907707db063817
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddContractSignToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type OpenSignContractComponent_addContractSignToSessionMutationVariables = {|
  input: AddContractSignToSessionInput
|};
export type OpenSignContractComponent_addContractSignToSessionMutationResponse = {|
  +addContractSignToSession: ?{|
    +contract: ?{|
      +id: string
    |},
    +contract_signature_block: ?{|
      +id: string
    |},
  |}
|};
export type OpenSignContractComponent_addContractSignToSessionMutation = {|
  variables: OpenSignContractComponent_addContractSignToSessionMutationVariables,
  response: OpenSignContractComponent_addContractSignToSessionMutationResponse,
|};
*/


/*
mutation OpenSignContractComponent_addContractSignToSessionMutation(
  $input: AddContractSignToSessionInput!
) {
  addContractSignToSession(input: $input) {
    contract {
      id
    }
    contract_signature_block {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddContractSignToSessionInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }
],
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addContractSignToSession",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddContractSignToSessionInput!"
      }
    ],
    "concreteType": "AddContractSignToSessionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contract",
        "storageKey": null,
        "args": null,
        "concreteType": "Contract",
        "plural": false,
        "selections": v1
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contract_signature_block",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractSignatureBlock",
        "plural": false,
        "selections": v1
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "OpenSignContractComponent_addContractSignToSessionMutation",
  "id": null,
  "text": "mutation OpenSignContractComponent_addContractSignToSessionMutation(\n  $input: AddContractSignToSessionInput!\n) {\n  addContractSignToSession(input: $input) {\n    contract {\n      id\n    }\n    contract_signature_block {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "OpenSignContractComponent_addContractSignToSessionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v2
  },
  "operation": {
    "kind": "Operation",
    "name": "OpenSignContractComponent_addContractSignToSessionMutation",
    "argumentDefinitions": v0,
    "selections": v2
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7254b02cd3d41fb4f4d7fc21d8ce8b16';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Share/__generated__/OpenSignContractComponent_addContractSignToSessionMutation.graphql.js